import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainService } from '../../common/services/main/main.service';
import { NgTemplateOutlet } from '@angular/common';
import { TopNavbarComponent } from '../../common/components/top-navbar/top-navbar.component';
import { LoaderComponent, CloseIconLgComponent } from '@mars/ui-components';
import { ClickOutSideDirective } from '@mars/ui-components';

@Component({
  selector: 'mars-main',
  standalone: true,
  imports: [
    RouterOutlet,
    NgTemplateOutlet,
    TopNavbarComponent,
    LoaderComponent,
    CloseIconLgComponent,
    ClickOutSideDirective,
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent {
  protected readonly mainService = inject(MainService);
}
